export default __webpack_public_path__ + "static/form-default-values-do-1082833d0e25440d28084afc2eed6cb7e69d05d16bc440fc1055c2be4d95684b.png";